import { render, staticRenderFns } from "./WorkflowChangelog.vue?vue&type=template&id=f6d61460&scoped=true"
import script from "./WorkflowChangelog.vue?vue&type=script&lang=js"
export * from "./WorkflowChangelog.vue?vue&type=script&lang=js"
import style0 from "./WorkflowChangelog.vue?vue&type=style&index=0&id=f6d61460&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d61460",
  null
  
)

export default component.exports